import React from 'react';
import { Button } from './ui/Button';
import { ScrollReveal } from './ui/ScrollReveal';
const wines = [{
  name: 'Single Block Range',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/SINGLE%20VINEYARD%20Ridge%20Shiraz.png'
}, {
  name: 'Estate Reserve Range',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/ESTATE%20Cabernet%20Sauvignon.png'
}, {
  name: 'GO Range',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GO%20Chardonnay.png'
}];
export function FeaturedWinesSection() {
  return <section id="wines" className="bg-charcoal py-32 md:py-48 px-6 md:px-12" data-id="element-44">
      <div className="max-w-7xl mx-auto" data-id="element-45">
        <ScrollReveal data-id="element-46">
          <h2 className="text-center text-5xl md:text-7xl font-semibold text-gold mb-24 tracking-tight" data-id="element-47">
            The Collection
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-24" data-id="element-48">
          {wines.map((wine, index) => <ScrollReveal key={index} delay={index * 0.2} className="h-full" data-id="element-49">
              <div className="group relative bg-chocolate h-full p-8 md:p-12 flex flex-col transition-all duration-500 hover:-translate-y-3 hover:shadow-[0_20px_50px_rgba(212,175,55,0.15)] border border-transparent hover:border-gold/30" data-id="element-50">
                {/* Bottle Image */}
                <div className="relative h-80 mb-10 mx-auto w-full flex justify-center items-center overflow-hidden" data-id="element-51">
                  {/* Dramatic lighting effect behind bottle */}
                  <div className="absolute w-24 h-full bg-gradient-to-b from-transparent via-white/5 to-transparent blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-52"></div>

                  <img src={wine.image} alt={wine.name} className="h-full object-contain drop-shadow-2xl transition-transform duration-700 group-hover:scale-105" data-id="element-53" />
                </div>

                {/* Content */}
                <div className="text-center mt-auto" data-id="element-54">
                  <h3 className="text-3xl font-semibold text-white mb-4" data-id="element-55">
                    {wine.name}
                  </h3>
                  <p className="text-gray-300 font-light leading-relaxed text-sm md:text-base opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-56">
                    {wine.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal delay={0.6} className="text-center" data-id="element-57">
          <Button variant="outline" className="border-gold text-gold hover:bg-gold hover:text-charcoal" data-id="element-58">
            Explore The Range
          </Button>
        </ScrollReveal>
      </div>
    </section>;
}